import type { AiCheckpointStatus } from 'core/hooks/AiPortrait/aiPortraitModel';
import { T, withAlpha } from 'services/ThemeTokens';

/**
 * ТЗ 0120 — цвета статуса чекпоинта портрета: значок, мягкий фон карточки и
 * её кромка. Только токены темы (`T`, `withAlpha`) — светлая и тёмная тема
 * без пересчёта. `ok` — зелёный, `warn` — жёлтый, `bad` — красный,
 * `unknown` — приглушённый серый.
 */
export interface IAiCheckpointColors {
  fg: string;
  bg: string;
  line: string;
}

export const AI_CHECKPOINT_COLORS: Readonly<
  Record<AiCheckpointStatus, IAiCheckpointColors>
> = {
  ok: { fg: T.ok, bg: withAlpha(T.ok, 0.06), line: withAlpha(T.ok, 0.32) },
  warn: {
    fg: T.warn,
    bg: withAlpha(T.warn, 0.07),
    line: withAlpha(T.warn, 0.36),
  },
  bad: {
    fg: T.danger,
    bg: withAlpha(T.danger, 0.06),
    line: withAlpha(T.danger, 0.34),
  },
  unknown: { fg: T.textMuted, bg: T.surfaceSubtle, line: T.border },
};
